import * as React from 'react';
import { SelectItem } from 'vet-bones/utils/select';

import { DiagramTransaction } from 'src/containers/ProjectDiagram/constants/transactions';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramWhileSkippingUndoManager } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { selectAttribute } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/selectAttribute';
import { projectAttributesByIriSelector } from 'src/selectors/projectAttributesByIri';
import { EntityDrawerType } from 'src/store/ui/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useClickModelConceptAttributeLink = () => {
  const { projectId } = useRouterParams();
  const diagram = useDiagram();
  const dispatch = useReduxDispatch();

  const attributesByIri = useReduxSelector(
    projectAttributesByIriSelector(projectId)
  );

  return React.useCallback(
    (item: SelectItem) => {
      if (!attributesByIri[item.value]) {
        return;
      }

      // Canvas highlight is the only diagram-dependent step; skip it headless.
      if (diagram && !diagram.headless) {
        commitDiagramWhileSkippingUndoManager(
          diagram,
          (_, diagram) => selectAttribute(item.value, true)(diagram),
          DiagramTransaction.SET_DIAGRAM_SELECTION
        );
      }

      dispatch(
        uiSlice.actions.changedEntityDrawer({
          projectId,
          drawer: {
            entityValue: item.value,
            type: EntityDrawerType.ATTRIBUTE,
          },
        })
      );
    },
    [attributesByIri, diagram, dispatch, projectId]
  );
};
